import { Icon, SliderModal, Text, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import { Box, Pressable } from 'native-base';
import React, { useCallback } from 'react';

import { SignedInRootStackParamList } from '../../../../../../../../routes/types';
import { Item } from '../Item';

interface DetailsProps {}

export const Details: React.FC<DetailsProps> = () => {
  const { canGoBack, goBack } = useNavigation();
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const sliderModalProps = useBreakpointValue({
    base: { width: 1, direction: 'bottom' },
    lg: { width: 0.45, direction: 'right' },
  });

  const { params } = useRoute<RouteProp<SignedInRootStackParamList, 'MyConsortiumDetails'>>();

  const handleGoBack = useCallback(() => {
    if (canGoBack()) {
      goBack();
    }
  }, [canGoBack, goBack]);

  return (
    <SliderModal dismissWhenClickOutside onDismiss={handleGoBack} {...sliderModalProps}>
      <VStack
        px={{ base: 0, sm: Spacing['inline.xxs'] }}
        pt={Spacing['inline.xxs']}
        pb={{ base: 0, sm: Spacing['inline.xxs'] }}
        space={Spacing['inline.xxxs']}
        bg="white"
        borderTopRadius={{ base: BoxRadius.md, lg: 0 }}>
        {sliderModalProps.direction === 'bottom' && (
          <Box
            w="55px"
            alignSelf="center"
            background={'neutral.lightest'}
            borderRadius={BoxRadius.sm}
            h={1}
          />
        )}
        <HStack
          alignItems="center"
          justifyContent="space-between"
          px={{ base: Spacing['inline.xxs'], sm: 0 }}>
          <Text variant="semibold" fontSize={Typography['fontsize.lg']} color="neutral.black">
            Detalhes do contrato
          </Text>
          <Pressable onPress={handleGoBack}>
            <Icon
              testID="input-clear-icon"
              name="Close"
              size="xxs"
              color={Color['neutral.black']}
              {...(!isMobile && {
                variant: 'rounded',
                borderWidth: 0.05,
                borderColor: Color['neutral.black'],
              })}
            />
          </Pressable>
        </HStack>
        <Item item={params} type="detail" />
      </VStack>
    </SliderModal>
  );
};
